<app-side-bar
  [mode]="mode()"
  [open]="drawerOpen()"
  (railToggle)="toggleRail()"
  (closeRequest)="closeDrawer()"
  (navigated)="closeDrawer()" />

@if (mode() === 'overlay' && drawerOpen()) {
  <div class="drawer-backdrop" (click)="closeDrawer()" aria-hidden="true"></div>
}

<app-main-header [mode]="mode()" (menuToggle)="openDrawer()" />

<div class="body-wrapper">
  <div class="ks-container">
    <router-outlet />
  </div>
</div>
